module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"reward":"+{0}원"}}')
  delete Component.options._Ctor
}
